/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CreditCardCreateIdResponseViewModel } from "../types/CreditCardCreateIdResponseViewModel.ts";

export const creditCardCreateIdResponseViewModelSchema = z.object({
  cardId: z.string().nullish(),
  firstSixDigits: z.string().nullish(),
  lastFourDigits: z.string().nullish(),
  brand: z.string().nullish(),
}) as unknown as ToZod<CreditCardCreateIdResponseViewModel>;
